import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Typography,
  Tooltip,
  Popover,
  makeStyles,
  IconButton,
  FormControl,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { updateTenantUser } from '@pingum/app-state-management/tenant/actions';

import styles from './styles';

const useStyles = makeStyles(styles);

export const UserNameComponent = (props) => {
  const {
    tenant,
    tenantUser,
    isLoading,
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [editFirstName, setEditFirstName] = useState(tenantUser.firstName);
  const [editLastName, setEditLastName] = useState(tenantUser.lastName);

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    // revert data
    setEditFirstName(tenantUser.firstName);
    setEditLastName(tenantUser.lastName);
    setAnchorEl(null);
  };

  const handleSaveName = () => {
    dispatch(updateTenantUser(tenant, tenantUser.auth0UserId, {
      email: tenantUser.email,
      firstName: editFirstName,
      lastName: editLastName,
    }));
    handleClosePopover();
  };

  return (
    <div>
      <Tooltip title="Update name" placement="left">
        <Typography
          variant="body2"
          onClick={(isLoading)
            ? () => {}
            : handleOpenPopover}
          className={classes.nameTypography}
        >
          <IconButton aria-label="Delete" className={classes.editButton} size="small" disabled={isLoading}>
            <EditIcon fontSize="inherit" />
          </IconButton>
          {tenantUser.firstName} {tenantUser.lastName}
        </Typography>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <form>
          <FormControl
            margin="normal"
            className={classes.textField}
            variant="outlined"
          >
            <InputLabel htmlFor="first-name">First Name</InputLabel>
            <OutlinedInput
              id="first-name"
              value={editFirstName}
              autoFocus
              onChange={(e) => setEditFirstName(e.target.value)}
              labelWidth={100}
            />
          </FormControl>
          <FormControl
            margin="normal"
            className={classes.textField}
            variant="outlined"
          >
            <InputLabel htmlFor="last-name">Last Name</InputLabel>
            <OutlinedInput
              id="last-name"
              value={editLastName}
              onChange={(e) => setEditLastName(e.target.value)}
              labelWidth={100}
            />
          </FormControl>
        </form>
        <Divider />
        <div className={classes.footer}>
          <Button
            onClick={handleClosePopover}
            id="cancel-edit-button"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveName}
            color="primary"
            variant="contained"
            autoFocus
            id="confirm-edit-button"
          >
            Save
          </Button>
        </div>
      </Popover>
    </div>
  );
};

UserNameComponent.propTypes = {
  tenant: PropTypes.string.isRequired,
  tenantUser: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
};
UserNameComponent.defaultProps = { isLoading: false };

export default UserNameComponent;
